import baseApi from './base.api'
import { normalizeFetchComponentsResponse } from './utils/normalizers/component.normalizers'
import { COMPONENT_TAG, createTagsForList } from './utils/tags'
import { actions } from '../reducers/assignment.reducer'

export const componentApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchComponents: builder.query({
            query: ({ token }) => ({
                url: `/cs-components/${token}`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchComponentsResponse,
            providesTags: result => createTagsForList(result, COMPONENT_TAG),
        }),
        reorderComponents: builder.mutation({
            query: ({ token, idToOrderMap }) => ({
                url: `/cs-components/${token}/reorder`,
                method: 'POST',
                body: idToOrderMap,
            }),
            invalidatesTags: [{ type: COMPONENT_TAG, id: 'LIST' }],
            onQueryStarted: ({ token }, { dispatch, queryFulfilled }) => {
                queryFulfilled.then(() => dispatch(actions.fetchLayers(token)))
            },
        }),
    }),
})

export const { useFetchComponentsQuery, useReorderComponentsMutation } = componentApi
